import React, { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from 'react-i18next';

import slugify from "slugify";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import { ConfigContext } from "../../../Context/ConfigContext";
import CatelogModal from "./CatelogModal";
import TabsItems from "./TabsItems";
import Tabs from "./Tabs";
import axios from "axios";
import { axiosGet } from "../../../Apis/axiosMethods";
const MobSection = ({ tabNameForeign, showAll }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const locale = localStorage.getItem('lang');
  const { gdcURL, PCID, setCategories, treeCategories } = useContext(ConfigContext);
  const dir = localStorage.getItem('dir');

  const [p_subs, setPsubs] = useState(null);
  const [p_index, setPindex] = useState(0);
  const [p_title, setPTitle] = useState(null);
  const [p_STR_ID, setPSTRID] = useState(null);
  // const [categories, setCategories] = useState([]);
  const [car, setCar] = useState([]);
  const [loading, setLoading] = useState(true);
  const { s_str_id } = useParams();
  const [stridtree, setSTRIDTree] = useState(s_str_id ? [Number(s_str_id), null] : [null]);


  const fetchCategories = async () => {
    window.scrollTo(0, 0);

    const storedPCID = localStorage.getItem('pc_id');

    try {
      setLoading(true);

      let response;

      if (storedPCID && storedPCID !== '' && storedPCID !== '0') {
        response = await axiosGet(`/Parts/GetCategoriesByCar?pc_id=${PCID}&lang=en`);
      } else {
        response = await axiosGet(`/Parts/GetCategories?lang=en`);
      }

      setCategories(response.data.data);
    } catch (err) {
      console.error("Category Fetch Error:", err);
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    fetchCategories()
  }, [PCID]);

  const [showModal, setShowModal] = useState(false);

  const handleShow = (subs, title, STR_ID, index) => {
    setPTitle(title);
    setPsubs(subs);
    setPSTRID(STR_ID);

    setPindex(Math.floor(((index) / 6)));
  }

  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedCategoryName, setSelectedCategoryName] = useState("...");
  const [selectedCategoryID, setSelectedCategoryID] = useState(0);
  const handleShowMenu = (subs, title, STR_ID) => {

    setSelectedCategoryName(title);
    setSelectedCategories(subs);
    setSelectedCategoryID(STR_ID)
    setShowModal(true);

  }
  return (<>
    <section className="feature-boxes-container" style={{ background: '#f7f7f7' }}>

      <div className="container" data-animation-name="fadeInUpShorter" >
        <div className="row">
          {treeCategories && treeCategories.slice(0, showAll === true ? 10000 : 12).map((item) => (
            <div onClick={() => handleShowMenu(item.children, item.STR_NODE_NAME, item.STR_ID)} key={item.STR_ID} className="col-6" style={{ backgroundColor: '#f5f5f5', border: '5px solid rgb(247, 247, 247)' }}>
              <img
                alt={item.STR_NODE_NAME}
                src={`${gdcURL}/category-images/600x600/${item.STR_ID}`}
                style={{ margin: 'auto', display: 'block' }}
              />
              <div style={{ position: 'relative' }}>
                <hr style={{ lineHeight: 0, margin: 0 }} />
                <div style={{
                  position: 'absolute',
                  left: '50%',
                  top: '50%',
                  transform: 'translate(-50%, -50%)',
                  width: '8px',
                  height: '8px',
                  borderRadius: '50%',
                  backgroundColor: '#cc000a'
                }}></div>
              </div>
              <div className="card-text text-center pl-2 pr-2 mb-1 mt-1" style={{ height: 70 }}>
                <span
                  style={{
                    fontFamily: "Montserrat, Arial, sans-serif",
                    fontSize: 17,
                    fontWeight: 500,
                    color: "rgb(3, 47, 74)"
                  }}
                >
                  {item.STR_NODE_NAME}
                </span>
              </div>
            </div>
          ))}
        </div>


      </div>
      {showAll === false && <center style={{ direction: dir === 'rtl' ? 'ltr' : '' }}><NavLink to={`/Spare-Parts/Catelog`}>{t('all_spare_parts_catelogue')} <i className="fas fa-chevron-right"></i></NavLink></center>}
      <br />
      <CatelogModal subs={selectedCategories} title={selectedCategoryName} STR_ID={selectedCategoryID} modalStatus={showModal} />
    </section>
  </>)

}

export default MobSection